import React, { useState, useRef } from 'react';

import Autocomplete from '@mui/material/Autocomplete';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';

import styles from './index.module.css';

interface IFiltersProps {
	applyTagFilters: () => void;
	clearTagFilters: () => void;
	updateTagFilters: (a: string, b: string | null) => void;
	stateListOptions: any;
	districtListOptions: any;
	tehsilListOption: any;
	villageListOption: any;
}

const Filters = ({
	applyTagFilters,
	clearTagFilters,
	stateListOptions,
	districtListOptions,
	tehsilListOption,
	villageListOption,
	updateTagFilters,
}: IFiltersProps) => {
	const changesCountRef: any = useRef(0);

	const [selectedState, setSelectedState] = useState<{
		label: string;
		value: string;
	} | null>(null);
	const [selectedDistrict, setSelectedDistrict] = useState<{
		label: string;
		value: string;
	} | null>(null);
	const [selectedTehsil, setSelectedTehsil] = useState<{
		label: string;
		value: string;
	} | null>(null);
	const [selectedVillage, setSelectedVillage] = useState<{
		label: string;
		value: string;
	} | null>(null);

	const disableApplyFiltersButton = () => {
		let flag = true;
		if (
			changesCountRef.current > 0 ||
			(selectedState && selectedState.value.length > 0) ||
			(selectedDistrict && selectedDistrict.value.length > 0) ||
			(selectedTehsil && selectedTehsil.value.length > 0) ||
			(selectedVillage && selectedVillage.value.length > 0)
		) {
			flag = false;
		}
		return flag;
	};

	const clearAllFields = () => {
		setSelectedState({
			label: '',
			value: '',
		});
		setSelectedDistrict({
			label: '',
			value: '',
		});
		setSelectedTehsil({
			label: '',
			value: '',
		});
		setSelectedVillage({
			label: '',
			value: '',
		});
	};

	const handleGeographyChange = (name: any, value: any) => {
		changesCountRef.current += 1;

		switch (name) {
			case 'TagProperty_STATE': {
				setSelectedState(value);
				updateTagFilters('TagProperty_STATE', value?.value ?? null);
				setSelectedDistrict(null);
				setSelectedTehsil(null);
				setSelectedVillage(null);
				break;
			}
			case 'TagProperty_DISTRICT': {
				setSelectedDistrict(value);
				updateTagFilters('TagProperty_DISTRICT', value?.value ?? null);
				setSelectedTehsil(null);
				setSelectedVillage(null);
				break;
			}
			case 'TagProperty_TEHSIL': {
				setSelectedTehsil(value);
				updateTagFilters('TagProperty_TEHSIL', value?.value ?? null);
				setSelectedVillage(null);
				break;
			}
			case 'LOCATION_AREA': {
				setSelectedVillage(value);
				updateTagFilters('LOCATION_AREA', value?.value ?? null);
				break;
			}
			default: {
				//
			}
		}
	};

	return (
		<div className={styles.filtersContainer}>
			<Autocomplete
				sx={{
					width: '100%',
					marginBottom: '12px',
				}}
				disablePortal
				id="machine-id-new"
				options={stateListOptions}
				value={selectedState}
				onChange={(e, value) => {
					handleGeographyChange('TagProperty_STATE', value);
				}}
				renderInput={(params) => (
					<TextField
						{...params}
						label="State"
						placeholder="Please select a state"
					/>
				)}
			/>
			<Autocomplete
				sx={{
					width: '100%',
					marginBottom: '12px',
				}}
				disablePortal
				id="machine-id-new"
				options={districtListOptions}
				value={selectedDistrict}
				onChange={(e, value) => {
					handleGeographyChange('TagProperty_DISTRICT', value);
				}}
				renderInput={(params) => (
					<TextField
						{...params}
						label="District"
						placeholder="Please select a district"
					/>
				)}
			/>
			<Autocomplete
				sx={{
					width: '100%',
					marginBottom: '12px',
				}}
				disablePortal
				id="machine-id-new"
				options={tehsilListOption}
				value={selectedTehsil}
				onChange={(e, value) => {
					handleGeographyChange('TagProperty_TEHSIL', value);
				}}
				renderInput={(params) => (
					<TextField
						{...params}
						label="Tehsil"
						placeholder="Please select a tehsil"
					/>
				)}
			/>
			<Autocomplete
				sx={{
					width: '100%',
					marginBottom: '12px',
				}}
				disablePortal
				id="machine-id-new"
				options={villageListOption}
				value={selectedVillage}
				onChange={(e, value) => {
					handleGeographyChange('LOCATION_AREA', value);
				}}
				renderInput={(params) => (
					<TextField
						{...params}
						label="Village"
						placeholder="Please select a village"
					/>
				)}
			/>
			<div className={styles.buttonContainer}>
				<Button
					variant="contained"
					disabled={disableApplyFiltersButton()}
					sx={{
						background: '#953730',
						// marginRight: '20px',
						borderRadius: '8px',
						':hover': {
							background: '#953730',
							scale: '1.01',
						},
					}}
					onClick={() => {
						applyTagFilters();
						changesCountRef.current = 0;
					}}
				>
					APPLY FILTERS
				</Button>
				<Button
					variant="contained"
					sx={{
						background: '#953730',
						// marginRight: '20px',
						borderRadius: '8px',
						':hover': {
							background: '#953730',
							scale: '1.01',
						},
					}}
					onClick={() => {
						clearTagFilters();
						clearAllFields();
						changesCountRef.current = 0;
					}}
				>
					CLEAR ALL FILTERS
				</Button>
			</div>
		</div>
	);
};

export default Filters;
